<template>
    <v-col cols="12">
      <v-card color="primary darken-1">
        <div v-if="showAnimation" style="height: 300px;">
          <loading-animation @loopComplete="loadAnimationComplete"></loading-animation>
        </div>
      </v-card>
      <rain-estimation
        v-show="!showAnimation && location"
        ref="EffluentsRainEstimation"
        :location="location"
        :forecasts="forecasts"
        :siprecDailyEstimated="siprecDailyEstimated"
        :basinIcon="basinIcon"
      ></rain-estimation>
    </v-col>
</template>

<script>
import RainEstimation from "../../common/RainEstimation/RainEstimation";
import LoadingAnimation from "../../common/LoadingAnimation";
import moment from "moment";
export default {
  components: {LoadingAnimation, RainEstimation},
  props: ['station'],
  name: "SeasonalRainfallEstimate",
  data:()=>({
    location: undefined,
    loading: false,
    showAnimation:false,
    basinIcon:{
      name: 'icon-infohidro-bacia', color: '#D97066'
    },
    source: ['26', '2', '22'],
    minDaysForecast: 29,
    maxDaysForecast: 6,
  }),
  watch:{
    station(val){
      if(val){
        this.location = this.station;
        this.initializeData();
      }
    }
  },
  mounted() {
    this.location = this.station;
    this.initializeData();
  },
  computed: {
    forecasts(){
      return this.$store.getters.forecasts;
    },
    siprecDailyEstimated(){
      return this.$store.getters.siprecDailyEstimated;
    },
    flowForecasts(){
      return this.$store.getters.flowForecasts;
    },
    watchForecastsValues(){
      return [this.forecasts, this.flowForecasts];
    },
  },
  methods: {
    loadAnimationComplete(){
      this.showAnimation = this.loading;
    },
    async initializeData() {
      this.loading = true;
      this.showAnimation = true;
      await Promise.all([
        this.$store.dispatch('loadForecastByLocationId', {
          type: 'daily',
          initial_date: moment().subtract(this.minDaysForecast, 'days').format('YYYY-MM-DD'),
          final_date: moment().add(this.maxDaysForecast, 'days').format('YYYY-MM-DD'),
          source: this.source,
          location_id: this.location.locationid,
          runtime: moment().format('YYYY-MM-DD')
        }),
        this.$store.dispatch("loadSiprecDailyEstimated", {
          startDate: moment()
            .subtract(179, "days")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          locationId: this.location.locationid,
        }),
      ]);
        this.loading = false;
    }
  }

}
</script>

<style scoped>
</style>
